import Cookies from 'js-cookie';
import { handleSessionExpiration } from 'src/utils/auth.utils';
import { getEncryptedLocalStorageData } from 'src/utils/dataStorageManagement.utils';
import {
  dataStorageKeywords,
  errorMessages,
  routeURL,
} from 'src/utils/properties.utils';

export async function getApiErrorMessage(error: any): Promise<string> {
  const isLoggedIn =
    (await getEncryptedLocalStorageData(dataStorageKeywords.IS_LOGGED_IN)) ===
    'true';
  const refreshToken = Cookies.get(dataStorageKeywords.REFRESH_TOKEN);

  if (error?.response) {
    const { status, data } = error.response;

    if ([401, 403].includes(status)) {
      if (isLoggedIn && !refreshToken) {
        handleSessionExpiration();
        return errorMessages.SESSION_EXPIRED;
      }
      return typeof data.message === 'string'
        ? data.message
        : errorMessages.ACCESS_DENIED;
    }

    if (data?.message) {
      try {
        return typeof data.message === 'string'
          ? data.message
          : errorMessages.SOMETHING_WENT_WRONG;
      } catch {
        return errorMessages.SOMETHING_WENT_WRONG;
      }
    }
  }

  return errorMessages.SOMETHING_WENT_WRONG;
}

interface EmailErrorParams {
  error: any;
  setMessage: (msg: string) => void;
  setSeverity: (type: 'success' | 'error') => void;
  setIsButtonDisabled: (disabled: boolean) => void;
  setRemainingTime: (time: number) => void;
  navigate: (url: string) => void;
  setExpired: (expired: boolean) => void;
}

export const handleEmailError = ({
  error,
  setMessage,
  setSeverity,
  setIsButtonDisabled,
  setRemainingTime,
  navigate,
  setExpired,
}: EmailErrorParams) => {
  const errorMsg = error?.response?.data?.message;
  setMessage(errorMsg);
  setSeverity('error');

  if (errorMsg === errorMessages.EMAIL_ALREADY_VERIFIED) {
    setIsButtonDisabled(true);
    setRemainingTime(0);
    localStorage.removeItem(dataStorageKeywords.TIMER_END_TIME);
    setTimeout(() => {
      navigate(routeURL.LOGIN);
    }, 2000);
    return;
  }

  if (error?.response?.data?.expired) {
    setIsButtonDisabled(true);
    setRemainingTime(0);
    setExpired(true);
    localStorage.removeItem(dataStorageKeywords.TIMER_END_TIME);
    return;
  }

  setIsButtonDisabled(false);
};
